import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { PRIMARY_COMPANY_ID } from 'src/app/contracts';
import { Auth } from 'src/app/core/common/auth';
import { IDisposable } from 'src/app/core/contracts';
import { Logger } from 'src/app/core/helpers/logger';
import { removeStorageItem } from 'src/app/core/helpers/storage';
import { Api } from '../core/common/api';

@Injectable({ providedIn: 'root' })
export class UserData implements IDisposable {
  private companyId = new BehaviorSubject<number | null>(null);
  constructor(private api: Api, private logger: Logger, private auth: Auth) {}
  get companyId$() {
    return this.companyId.asObservable();
  }
  async dispose() {
    await removeStorageItem(PRIMARY_COMPANY_ID);
    this.companyId.next(null);
    return Promise.resolve();
  }
}
